<template>
  <div>
    <div class="websiteHealthStatus-title">
      <div>{{ $t("alarms.websiteHealthStatus.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'nonCloudResources:websiteHealthStatus:add_alert_rule'
          ]"
          @click="addOrUpdateHandle"
          >{{
            $t("alarms.websiteHealthStatus.addWebsiteHealthStatusAlarm")
          }}</Button
        >
        <add-or-update-website-health-status-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-website-health-status-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.common.alertRule')">
          <div class="websiteHealthStatus-top">
            <website-health-status-warning-search></website-health-status-warning-search>
          </div>
          <table-website-health-status-warning></table-website-health-status-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import WebsiteHealthStatusWarningSearch from "../website_health_status/WebsiteHealthStatusWarningSearch";
import TableWebsiteHealthStatusWarning from "../website_health_status/TableWebsiteHealthStatusWarning";
import AddOrUpdateWebsiteHealthStatusWarning from "../website_health_status/AddOrUpdateWebsiteHealthStatusWarning";

export default {
  name: "WebsiteHealthStatus",
  components: {
    WebsiteHealthStatusWarningSearch,
    TableWebsiteHealthStatusWarning,
    AddOrUpdateWebsiteHealthStatusWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /***************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.websiteHealthStatus-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}

.websiteHealthStatus-title > div:nth-child(1) {
  float: left;
}

.websiteHealthStatus-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}

.websiteHealthStatus-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/non_cloud_resources/website_health_status/WebsiteHealthStatus.vue